module.exports = __webpack_public_path__ + "img/台区.b9bd4d68.png";